export const swal2Icons = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  question: 'question'
}

export const defaultSwal2Options = () => ({
  reverseButtons: true,
  buttonsStyling: false
})

export const swal2CustomIcons = {
  success: '/img/icon/swal/icon-success.svg',
  error: '/img/icon/swal/icon-error.svg',
  warning: '/img/icon/swal/icon-warning.svg',
  info: '/img/icon/swal/icon-info.svg',
  question: '/img/icon/swal/icon-question.svg'
}

export const swal2CustomIconsWithImg = {
  success: `<img src="${swal2CustomIcons.success}" alt="icon-swal2-custom-${swal2Icons.success}">`,
  error: `<img src="${swal2CustomIcons.error}" alt="icon-swal2-custom-${swal2Icons.error}">`,
  warning: `<img src="${swal2CustomIcons.warning}" alt="icon-swal2-custom-${swal2Icons.warning}">`,
  info: `<img src="${swal2CustomIcons.info}" alt="icon-swal2-custom-${swal2Icons.info}">`,
  question: `<img src="${swal2CustomIcons.question}" alt="icon-swal2-custom-${swal2Icons.question}">`
}

export const getSwal2IconHtmlFromIcon = (icon) => {
  const iconHtml = swal2CustomIconsWithImg[icon]
  if (!iconHtml) {
    return ''
  }

  return iconHtml
}
